import React from 'react';

export const metricValue = ({value, format, currency='USD'}) => {
  if (value == null) return '—';
  if (format === 'money') {
    const parts = String(value).match(/^(-?)(\d+)(?:\.(\d+))?$/);
    if (parts) {
      const fraction = (parts[3] || '').padEnd(3, '0');
      const cents = BigInt(parts[2]) * BigInt(100) + BigInt(fraction.slice(0, 2)) + BigInt(Number(fraction[2]) >= 5 ? 1 : 0);
      return `${parts[1]}${(cents / BigInt(100)).toLocaleString('en-GB')}.${String(cents % BigInt(100)).padStart(2, '0')} ${currency}`;
    }
  }
  const text = Number(value).toLocaleString('en-GB', {
    maximumFractionDigits: format === 'percent' ? 1 : 2,
    minimumFractionDigits: format === 'money' ? 2 : 0,
  });
  return format === 'percent' ? `${text}%` : format === 'money' ? `${text} ${currency}` : text;
};

// Названия, применимость и формулы приходят из серверного справочника.
export default function MetricValues({metrics = [], compact = false}) {
  return <dl className={`metric-values${compact ? ' metric-values-compact' : ''}`}>
    {metrics.map((metric) => <div key={metric.key}>
      <dt><abbr title={metric.hint} tabIndex={0}>{metric.label}</abbr></dt>
      <dd>{metricValue(metric)}</dd>
    </div>)}
  </dl>;
}
